import styles from "./ChartContainer.module.css";
type Props = {};
export default function ChartContainer(
  props: React.HTMLAttributes<HTMLDivElement>
) {
  return <div className={`${styles.chartContainer} borderBox`} {...props} />;
}
